import { connect } from 'react-redux'
import { createSelector } from 'reselect'

import { getEntityMap } from 'data'
import { getChannel } from 'data/channels/selectors'
import { recursivelyGetNotePathIds, getNote } from 'data/notes/selectors'

import { isPersonal, isPrivate } from 'data/channels/record'

const loadingState = {
  isLoading: true,
  note: null,
  channel: null,
  isPersonal: false,
  isPrivate: false,
}

function makeMapStateToProps() {
  const getNoteParents = createSelector(
    state => getEntityMap(state, 'Note'),
    (_, noteId) => noteId,
    (allNotes, noteId) => {
      if (!noteId) {
        return []
      }
      return recursivelyGetNotePathIds(allNotes, noteId)
        .reverse()
        .map(noteId => allNotes.get(noteId))
        .filter(x => x)
    }
  )

  return function mapStateToProps(state, { noteId }) {
    const note = getNote(state, noteId)
    if (!note) {
      return loadingState
    }

    const channel = getChannel(state, note.channelId)
    if (!channel) {
      return loadingState
    }

    const parentNotes = getNoteParents(state, noteId)
    return {
      isLoading: Boolean(!note),
      note,
      channel,
      parentNotes,
      isPersonal: isPersonal(channel),
      isPrivate: isPrivate(channel),
    }
  }
}

export default connect(makeMapStateToProps)
